import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { apiLink } from "../../../constant/api-link";
import { LocalStorageService } from "angular-2-local-storage";
import { ProjectProductModel } from "../../../model/builk/coupon/project-product.model";
import { CouponItemModel, CouponListModel, CouponListQueryModel, CreateProjectCouponModel, CreateProjectFreeCouponModel, ResponseCouponModel } from "../../../model/builk/coupon/project-coupon.model";
import { ProjectPackageItemModel } from "../../../model/builk/coupon/project-package.model";

@Injectable({
    providedIn: "root"
})
export class CouponService {

    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService
    ) { }

    sub: any;

    getProduct(): Observable<Array<ProjectProductModel>> {
        const url = apiLink.getProductList;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.get<Array<any>>(url, { headers });
    }

    getPackage(): Observable<Array<ProjectPackageItemModel>> {
        const url = apiLink.getPackageForCoupon;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.get<Array<ProjectPackageItemModel>>(url, { headers });
    }

    createProduct(model: Array<ProjectProductModel>): Observable<boolean> {

        const url = apiLink.createProduct;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.post<boolean>(url, model, { headers });
    }

    createCoupon(model: CreateProjectCouponModel): Observable<ResponseCouponModel> {

        const url = apiLink.createCoupon;
        const body = {
            couponCode: model.couponCode,
            couponCalcType: model.couponCalcType,
            couponDiscountValue: model.couponDiscountValue,
            couponStartDate: model.couponStartDate,
            couponMinimumDiscount: model.couponMinimumDiscount,
            couponPackageCondition: JSON.stringify(model.couponPackageCondition),
            createUserId: model.createUserId,
            couponDescription: model.couponDescription,
            projProdSurrKey: model.projProdSurrKey
        };
        if (model.couponEndDate !== null && model.couponEndDate !== undefined) {
            body["couponEndDate"] = model.couponEndDate;
        }
        if (model.couponCompanyQuotaLimit !== null && model.couponCompanyQuotaLimit !== undefined) {
            body["couponCompanyQuotaLimit"] = model.couponCompanyQuotaLimit;
        }
        if (model.couponQuotaLimit !== null && model.couponQuotaLimit !== undefined) {
            body["couponQuotaLimit"] = model.couponQuotaLimit;
        }
        if (model.couponMaximumDiscount !== null && model.couponMaximumDiscount !== undefined) {
            body["couponMaximumDiscount"] = model.couponMaximumDiscount;
        }
        const headers = new HttpHeaders({ "Content-Type": "application/json" });
        //console.log(JSON.stringify(body));
        return this.http.post<ResponseCouponModel>(url, body, { headers });
    }

    getCoupon(query: CouponListQueryModel): Observable<CouponListModel> {
        const url = apiLink.getCoupon;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });
        let params = new HttpParams()
        .set("PageNumber", query.pageNumber.toString())
        .set("PageSize", query.pageSize.toString())
        .set("SortByDesc", query.sortByDesc.toString())
        .set("SortColumn", query.sortColumn.toString());
        if (query.couponType != null && query.couponType != undefined && query.couponType != 0) {
            params = params.append('CouponType', query.couponType.toString());
        }
        if (query.textSearch != null && query.textSearch != undefined && query.textSearch != '') {
          params = params.append('TextSearch', query.textSearch.toString());
        }
        return this.http.get<CouponListModel>(url, { params: params });
    }

    updateCoupon(model: Array<CouponItemModel>): Observable<boolean> {

        const url = apiLink.updateCoupon;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.put<boolean>(url, model, { headers });
    }

    createFreeCoupon(model: CreateProjectFreeCouponModel): Observable<Array<ResponseCouponModel>> {

        const url = apiLink.createFreeCoupon;
        const body = {
            couponCode: model.couponCode,
            couponStartDate: model.couponStartDate,
            couponPackageCondition: JSON.stringify(model.couponPackageCondition),
            createUserId: model.createUserId,
            couponDescription: model.couponDescription,
            projProdSurrKey: model.projProdSurrKey
        };
        if (model.couponEndDate !== null && model.couponEndDate !== undefined) {
            body["couponEndDate"] = model.couponEndDate;
        }
        if (model.couponQuotaLimit !== null && model.couponQuotaLimit !== undefined) {
            body["couponQuotaLimit"] = model.couponQuotaLimit;
        }
        const headers = new HttpHeaders({ "Content-Type": "application/json" });
        //console.log(JSON.stringify(body));
        return this.http.post<Array<ResponseCouponModel>>(url, body, { headers });
    }
}
